export const environment = {
    prodMode: true,
    sidebarExcludedRoutes: ['logout','**']
};
